import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { ANY_ERROR } from '../../../../action/user_action_types';

import { fileUrl } from '../../../../config';
import SideBar from '../../common/sideBar';
import { history } from '../../../../history/history';

import { getCityState } from '../../../../action/user_action';
import { endPoints } from '../../../../config';
import http from '../../../../util/http';

import { getServerDataWithTypes } from '../../../../action/common_action';
import { SALES_USERS_DATA, STATE_LIST } from '../../../../action/salesUser_action_types';
import { axiosInstnace as Axios } from '../../../../util/util';
// import { Multiselect } from 'multiselect-react-dropdown';
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css"
import HeaderAdminpanel from '../../common/HeaderAdminpanel';

class AddCluster extends Component {
  constructor(props) {
    super(props);
    this.handleChangeSelectedItems = this.handleChangeSelectedItems.bind(this);
    this.state = {
      adminField: {
          email: "",
          name:"",
          mobile:"",
          role:"",
          state:"",
          city:"",
          station:""
      },

      stateList : [
          "Select State"
      ],
      cityList:["Select City"],

      stationList:[
                "Select Station",
                "Tirupati",
                "Itanagar",
                "Guwahati",
                "Muzaffarpur",
                "Patna",
                "Chandigarh",
                "Delhi",
                "Panaji",
                "Baroda",
                "Rajkot",
                "Surat",
                "Hisar",
                "Shimla",
                "Jammu",
                "Srinagar",
                "Jamshedpur",
                "Ranchi",
                "Bangalore",
                "Mangalore",
                "Mysore",
                "Trivandrum",
                "Gwalior",
                "Bhopal",
                "Indore",
                "Ahmednagar",
                "Aurangabad",
                "Kolhapur",
                "Nagpur",
                "Sholapur",
                "Mumbai",
                "Pune",
                "Shillong",
                "Aizawl",
                "Bhubaneshwar",
                "Rourkela",
                "Pondicherry",
                "Amritsar",
                "Jalandhar",
                "Patiala",
                "Ajmer",
                "Bikaner",
                "Jodhpur",
                "Kota",
                "Udaipur",
                "Chennai",
                "Hyderabad",
                "Agartala",
                "Agra",
                "Aligarh",
                "Allahabad",
                "Bareilly",
                "Gorakhpur",
                "Jhansi",
                "Kanpur",
                "Lucknow",
                "Varanasi",
                "Asansol",
                "Kolkata"
            ],
     
      roleList: [
          {role:"", name: "Select Role"},
          {role:"salesUser", name: "Sales User"},
          {role:"auditAdmin", name: "Audit Admin"},
          {role:"stationAdmin", name: "Station Admin"},
          {role:"trafficAdmin", name: "Traffic Admin"}
      ],
      districtList: ["Select District"],
      clusterName: "",
      clusterCities: [],
      clusterStates: []


  };
  };

  componentDidMount = () => {
    this.getAllStates();
}

getAllStates = async() => {
    this.props.getStateList(`${endPoints.getStateList}`, STATE_LIST);
    // const response = await Axios.get(`${endPoints.getClusters}`);
    // console.log(response)
    this.getCityList('');

}

getDistrictList = async(state) => {
    const response = await Axios.get(`${endPoints.getDistrictList}?state=${state}`);
    console.log(response.data.data.data);
    let districtList = response.data.data.data;
    this.setState({
        districtList: districtList ? districtList : []
    })
}

getCityList = async(state) => {
    const response = await Axios.get(`${endPoints.getCities}?state=${state}`);
    console.log(response.data.data.data);
    let districtList = response.data.data.data;
    let cityListItems = [];
    await districtList.forEach(city => {
      console.log(city);
      let item = {
        id: city._id,
        label: city.city,
        group: city.state,
        city: city.city,
        state: city.state
      }
      cityListItems.push(item);
    }) 
    this.setState({
        cityList: cityListItems ? cityListItems : []
    })
}

componentWillReceiveProps = nextProps => {
    console.log('on Data receive props on Add cluster page', nextProps);
    let {stateList} = nextProps;
    this.setState({
        stateList: (stateList && stateList.data) ? stateList.data : []
    })
}

handleStateChange = event => {
    console.log(event);
    this.state.adminField.state = event;
    this.getCityList(event);

};
handleChangeSelectedItems(clusterCities) {
  console.log(clusterCities);
  this.setState({ clusterCities });
}

handleClusterCitiesByState = async()=> {
  const response = await Axios.get(`${endPoints.getCities}?state=${this.state.adminField.state}`);
  console.log(response.data.data.data);
  let cityList = response.data.data.data;
  this.state.clusterStates.push(this.state.adminField.state);
  console.log(cityList);
  cityList.forEach(city => {
    this.state.clusterCities.push(city.city);
  })
}

handleStationChange = event => {
    this.state.adminField.station = event;
};

handleCityChange = (selectedList, selectedValue) => {
    console.log(selectedList, selectedValue);
    this.state.clusterCities.push(selectedValue.city);
    console.log(this.state.clusterCities);
};

handleRoleChange = event => {
    this.state.adminField.role = event;
}

serverCalls= async(url, data)=> {
    const response= await http.post(url, data);
    if(response && response.data.statusCode== 200) {
        // this.componentDidMount();
        var data = response.data.data[0] ? response.data.data[0] : response.data.data ;
        console.log('Response', data);
        // this.state.adminField.name = data.name;
        // this.state.adminField.email = data.email;
      this.goToRoute('clusterlist', null, '/admin/clusterlist')

    }
    else {
        this.props.showError(response? response.data.message: "Something is wrong");
    }
}


//Handle the admin fields
handleChange = event => {
    console.log(event.target.value);
    this.state.adminField.name = event.target.value;
    console.log('Changed value', this.state.adminField);
}

addClusters = () => {
  let adminInfo = JSON.parse(localStorage.getItem('adminInfo')) ;
  console.log(adminInfo);
  let data = {
    name:this.state.adminField.name,
    stateList : this.state.clusterStates,
    cityList: this.state.clusterCities,
    email: adminInfo.email
  }
  if(this.state.adminField.name && this.state.adminField.name != ""){
    if((this.state.clusterCities && this.state.clusterCities.length >0 || this.state.clusterStates && this.state.clusterStates.length>0)){
      this.serverCalls(endPoints.createCluster, data);
    }else {
      this.props.showError('Please Add a State or City to the List ');
    }

  }else {
    this.props.showError('Please Enter name');
  }
}

  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  }

  //View campaign info
  render() {
    let { adminField } = this.state;
    let { hidePopup }= this.props;
    let { name }= adminField;
    const { cityList, clusterCities } = this.state;

    return (
      <div>
        <div className="dashboardContainer">
          <HeaderAdminpanel/>
          <div className="dashboardContainer-inner">
                <section id="sidebar">
                 <SideBar />          
                </section>
            <section id="dashboard-rightContainer" className="dashboard-manageSales brands-head">
              <div className="container-head">
                <div className="dashboard-breadcrumb">System Configuration | Cluster List |
                  <span className="blue_camp">Add Cluster</span></div>
              </div>

              <table className="tableView">
                  <tr>
                      <td>
                          <label htmlFor="email">Name</label>
                      </td>
                      <td>
                          <input type= "email" name= "email" placeholder="Name" onChange= {this.handleChange}  className="width200 inputBox" />
                      </td>

                      <td>
                          <label htmlFor="email">State</label>
                      </td>

                      <td>
                      <select className="typeDropdown drop-down-icon width200" onChange= {event =>this.handleStateChange(event.target.value)} >
                          {this.state.stateList.map((state, index)=> (
                              <option key= {index}>{state}</option>
                          ))}
                      </select>
                      </td>

                      
                  </tr>
                  <tr>
                      
                  </tr>
              </table>

              <MultiSelect
                items={cityList}
                selectedItems={clusterCities}
                onChange={this.handleChangeSelectedItems}
                withGrouping
              />

              <div className="view-btn_wrapper">
                <button className="cluster-add-btn" onClick={this.addClusters}>{"ADD"}</button>
                <button className="cluster-add-btn"
                  onClick={() => this.goToRoute('clusterlist', null, '/admin/clusterlist')}>BACK</button>
              </div>
              
            </section>
          </div>
        </div>
      </div>
    );
  };
};

const mapStateToProps = state => { console.log(state);
  return {
    stateList: state.sales.get("stateList")
  }
};
const mapDispatchToProps = dispatch => {
  return {
    showError: error => dispatch({
      type: ANY_ERROR,
      payload: error
    }),
    getStateList: (url, data, type) => dispatch(getServerDataWithTypes(url, data, type))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddCluster);



// WEBPACK FOOTER //
// ./web/components/admin/users/salesUser/AddCluster.jsx